/**
 * Quiz "Connaissez-vous nos cépages ?" — Vignerons de la Cave de Pierrefeu
 * Données fixes (8 cépages), pas besoin de sheet externe.
 */
(function () {
  var CEPAGES = [
    { nom: "Grenache", clue: "Résistant à la sécheresse et généreux en production, il donne des vins tanniques, riches en alcool.", fait: "Le Grenache résiste bien à la sécheresse et est assez productif. Il donne des vins tanniques et riches en alcool." },
    { nom: "Syrah", clue: "Cépage noble et complexe, il offre des vins très aromatiques.", fait: "La Syrah est un cépage de qualité. Elle donne des vins très aromatiques et complexes." },
    { nom: "Cinsault", clue: "Il donne des vins fins et aromatiques, et des rosés à la couleur très pâle.", fait: "Le Cinsault donne des vins aromatiques et fins, et des rosés très clairs." },
    { nom: "Rolle", clue: "Cépage blanc qualitatif, il apporte des arômes de fruits exotiques.", fait: "Le Rolle est un cépage qualitatif qui apporte des arômes de fruits exotiques." }
  ];

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function buildQuestions() {
    return shuffle(CEPAGES).map(function (c) {
      var distractors = shuffle(CEPAGES.filter(function (x) { return x.nom !== c.nom; })).slice(0, 3);
      var options = shuffle([c].concat(distractors));
      return { correct: c, options: options };
    });
  }

  function init(root) {
    var questions = buildQuestions();
    var index = 0;
    var score = 0;

    function renderQuestion() {
      var q = questions[index];
      root.innerHTML =
        '<div class="cq-box">' +
        '<p class="cq-eyebrow">Connaissez-vous nos cépages ?</p>' +
        '<p class="cq-progress">Question ' + (index + 1) + ' sur ' + questions.length + "</p>" +
        '<p class="cq-clue">' + q.correct.clue + "</p>" +
        '<div class="cq-options" data-cq-options>' +
        q.options.map(function (o, i) {
          return '<button type="button" class="cq-option" data-cq-opt="' + i + '">' + o.nom + "</button>";
        }).join("") +
        "</div>" +
        '<div class="cq-feedback" data-cq-feedback></div>' +
        "</div>";

      var buttons = root.querySelectorAll("[data-cq-opt]");
      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var chosen = q.options[parseInt(btn.dataset.cqOpt, 10)];
          var isCorrect = chosen.nom === q.correct.nom;
          if (isCorrect) score++;

          buttons.forEach(function (b) {
            b.disabled = true;
            var opt = q.options[parseInt(b.dataset.cqOpt, 10)];
            if (opt.nom === q.correct.nom) b.classList.add("is-correct");
            else if (b === btn) b.classList.add("is-wrong");
          });

          var feedback = root.querySelector("[data-cq-feedback]");
          feedback.innerHTML =
            (isCorrect ? "Exact ! " : "Pas tout à fait. La réponse était <strong>" + q.correct.nom + "</strong>. ") +
            q.correct.fait +
            '<button type="button" class="cq-next" data-cq-next>' +
            (index + 1 < questions.length ? "Question suivante" : "Voir mon résultat") +
            "</button>";
          feedback.classList.add("is-visible");

          root.querySelector("[data-cq-next]").addEventListener("click", function () {
            index++;
            if (index < questions.length) renderQuestion();
            else renderEnd();
          });
        });
      });
    }

    function renderEnd() {
      var message;
      if (score === questions.length) message = "Un sans-faute ! Vous connaissez nos cépages aussi bien qu'un vigneron.";
      else if (score >= questions.length * 0.6) message = "Du bon nez ! Encore quelques dégustations et vous serez incollable.";
      else message = "Pas mal pour un premier passage — le meilleur moyen d'apprendre reste de goûter.";

      root.innerHTML =
        '<div class="cq-box cq-end">' +
        '<p class="cq-eyebrow">Résultat</p>' +
        '<p class="cq-end-score">' + score + " / " + questions.length + "</p>" +
        '<p class="cq-end-message">' + message + "</p>" +
        '<button type="button" class="cq-restart" data-cq-restart>Recommencer</button>' +
        "</div>";

      root.querySelector("[data-cq-restart]").addEventListener("click", function () {
        questions = buildQuestions();
        index = 0;
        score = 0;
        renderQuestion();
      });
    }

    renderQuestion();
  }

  document.querySelectorAll("[data-cepages-quiz]").forEach(init);
})();